import BusinessIcon from '@mui/icons-material/Business';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import ListAltIcon from '@mui/icons-material/ListAlt';
import LogoutIcon from '@mui/icons-material/Logout';
import SettingsIcon from '@mui/icons-material/Settings';
import { AppBar, Box, Button, CssBaseline, Toolbar, Typography, useTheme } from '@mui/material';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useBrand } from '../contexts/BrandContext';

export const PlatformLayout = () => {
  const { logout } = useAuth();
  const { brandConfig, logo } = useBrand();
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  const navButtonStyle = (isActive) => ({
    color: theme.brand?.headerTextColor || '#000',
    textTransform: 'none',
    borderBottom: isActive ? '2px solid' : '2px solid transparent',
    borderRadius: 0,
    px: 2,
    '&:hover': {
      bgcolor: theme.brand?.headerTextColor === '#FFFFFF' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.08)',
    },
  });

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', width: '100%' }}>
      <CssBaseline />
      <AppBar
        position="static"
        sx={{
          background: theme.brand?.platformGradient || theme.palette.primary.main,
        }}
      >
        <Toolbar>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <img src={logo} alt={brandConfig.name} style={{ height: '32px', width: '32px' }} />
            <Typography variant="h6" component="div" sx={{ color: theme.brand?.headerTextColor || '#000', mr: 4 }}>
              {brandConfig.name} - 運営管理
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', gap: 1, flexGrow: 1 }}>
            <Button
              startIcon={<BusinessIcon />}
              onClick={() => navigate('/ops')}
              sx={navButtonStyle(location.pathname === '/ops' || location.pathname.startsWith('/ops/organizations'))}
            >
              組織管理
            </Button>
            <Button
              startIcon={<LibraryBooksIcon />}
              onClick={() => navigate('/ops/knowledge')}
              sx={navButtonStyle(location.pathname === '/ops/knowledge')}
            >
              ナレッジ管理
            </Button>
            <Button
              startIcon={<ListAltIcon />}
              onClick={() => navigate('/ops/history')}
              sx={navButtonStyle(location.pathname === '/ops/history')}
            >
              対応一覧
            </Button>
            <Button
              startIcon={<SettingsIcon />}
              onClick={() => navigate('/ops/system-settings')}
              sx={navButtonStyle(location.pathname === '/ops/system-settings')}
            >
              システム設定
            </Button>
          </Box>
          <Button
            onClick={handleLogout}
            startIcon={<LogoutIcon />}
            sx={{
              color: theme.brand?.headerTextColor || '#000',
              textTransform: 'none',
              '&:hover': {
                bgcolor:
                  theme.brand?.headerTextColor === '#FFFFFF' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.08)',
              },
            }}
          >
            ログアウト
          </Button>
        </Toolbar>
      </AppBar>
      <Box component="main" sx={{ flexGrow: 1 }}>
        <Outlet />
      </Box>
    </Box>
  );
};
